import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Breadcrumb, LazyLoadingPagination, ListItem, TabsData } from '@material-library';
import { SyncCryptService } from 'src/app/core/crypt/sync-crypt.service';
import { FileItemService } from 'src/app/file/file-item.service';
import { DirPickerView, FileItem, WebpathActionType } from 'src/app/shared/models';
import { BatchMoveService } from 'src/app/shared/services/batch-move.service';
import { DirPickerService } from 'src/app/shared/services/dir-picker.service';
import { IBatchActionView, IFile } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ApiService } from 'src/app/core/api.service';
import { UserService } from 'src/app/core/user.service';
import { MoveActionsService } from 'src/app/shared/services/move-actions.service';
import { FileListService } from 'src/app/file-list/services/file-list.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-move-select-destination-dir',
  templateUrl: './move-select-destination-dir.component.html',
  styleUrls: ['./move-select-destination-dir.component.scss']
})
export class MoveSelectDestinationDirComponent implements OnInit, OnDestroy {
  @Input() syncId: number;
  @Input() public selectedRows: IFile[] = [];
  @Input() actionMoveOrCopy: WebpathActionType = WebpathActionType.MOVE;
  @Input() openRootFlag: boolean;
  @Input() defaultTab: 'Files' | 'Vault' = 'Files';
  @Output() nameConflictsChange : EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() destinationDataChange = new EventEmitter<FileItem[]>();

  public batchView: IBatchActionView;
  public pickerView: DirPickerView;
  public itemList: IFile[] = [];
  public dirList: ListItem[] = [];
  public itemListForLazyLoadData: ListItem[] = [];
  public breadCrumbItems: any;
  public tabLinks: TabsData[] = [];
  public sync_id_array: number[] = [];
  public activeTab: string = 'Files';
  public skipShareFolders = 0;
  public isLoading: boolean = true;
  public shouldDuplicate = false;
  public isSmallScreen: boolean;
  public showInfoOfAlreadyInFolder: number = 0;
  public activateScroll: boolean = false;
  private selectedRowDirObject: { [key: string]: boolean } = {};
  lastItemIndex: number = 0;
  private itemLoadLimit: number = 16;
  public loadMore: boolean = true;
  public WebpathActionType = WebpathActionType;
  public alertConfig: any = {
    type: 'info',
    description: '',
    leadIcon: 'folder-open',
  };
  private breakpointSubscribe: Subscription;
  isSelectedItemsInCurrentDir = false;
  private isParentSharedInSelectedList: { [key: string]: boolean } = {};

  constructor(
    public dirPickerService: DirPickerService,
    public breakpointObserver: BreakpointObserver,
    private batchMoveService: BatchMoveService,
    private changeDetectorRef: ChangeDetectorRef,
    private fileItemService: FileItemService,
    private crypt: SyncCryptService,
    private apiService: ApiService,
    private userService: UserService,
    private moveActionsService: MoveActionsService,
    private fileListService: FileListService,
  ) { }

  async ngOnInit() {
    this.showInfoOfAlreadyInFolder = 0;
    this.itemList = [...this.selectedRows];
    this.isParentSharedInSelectedList = await this.isSharedItemInSelectedList(this.itemList);
    this.alertConfig = {
      type: 'info',
      description: `Choose where you would like to put the shared folder <span class="folder-name">${this.itemList[0].name}</span> on your Sync account.`,
      leadIcon: 'folder-open',
    };
    this.breakpointSubscribe = this.breakpointObserver.observe([
      '(max-width: 904px)',
    ])
      .subscribe((state: BreakpointState) => {
        if (state.breakpoints['(max-width: 904px)']) {
          this.isSmallScreen = true;
        } else {
          this.isSmallScreen = false;
        }
      });


    this.dirPickerService.view.skipSyncIds = [];
    this.selectedRowDirObject = {};
    for (let i = 0, len = this.itemList.length; i < len; i++) {
      if (this.actionMoveOrCopy === WebpathActionType.MOVE)
        // this.dirPickerService.view.skipSyncIds.push(this.itemList[i].sync_id);
        if (this.itemList[i].type === 'dir') {
          this.selectedRowDirObject[this.itemList[i].sync_id] = true;
        }
    }
    
    this.activeTab = this.defaultTab;

    this.pickerView = this.dirPickerService.view;
    this.loadTabs();
    if (this.openRootFlag) {
      await this.openRoot('sync');
    } else {
      this.getListFromFileList(this.pickerView.dirlist);
    }
    this.updateBreadcrumbItems();
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscribe) {
      this.breakpointSubscribe.unsubscribe();
    }
  }

  handleMenuItemClick = async (item: any) => {
    if(item.value === this.dirPickerService.getRootSyncId){
      this.activeTab = 'Files'
    }else if(item.value === this.dirPickerService.getRootVaultId){
      this.activeTab = 'Vault'
    }
    this.loadTabs();
    await this.cd(item?.value || item.url);

    const itemData = await this.fileListService.getDataNoState(item?.value || item.url, '0');
    this.select(itemData.cwd);
  }

  handleBackClick = (item: any) => {
    this.cdUp()
  }


  handleScroll = async (scrolled: boolean) => {

    if (this.loadMore && scrolled && !this.activateScroll) {
      this.activateScroll = true;
      this.distributedDirectoryList();
    }
  }
  distributedDirectoryList = () => {

    const lastInd = this.lastItemIndex + this.itemLoadLimit;
    const endInd = this.dirList.length < lastInd ? this.dirList.length : lastInd;
    this.lastItemIndex = endInd
    const result = this.dirList.slice(0, endInd);
    if (result && result.length) {
      this.itemListForLazyLoadData = [...result];
      if (this.itemListForLazyLoadData.length === this.dirList.length) {
        this.loadMore = false;
      }
    }
    this.activateScroll = false;
    this.isLoading = false;
  };

  onTabChange = (event: TabsData) => {
    this.activeTab = event.label;
    this.loadTabs();
    if (this.activeTab === 'Files') {
      this.openRoot('sync');
    } else {
      this.openRoot('vault');
    }
  };

  loadTabs = () => {
    this.tabLinks = [
      {
        label: 'Files',
        activeLink: this.activeTab === 'Files',
        iconAdornmentConfig: {
          enabled: true,
          type: 'icon',
          size: 'large',
          iconName: 'folder'
        },
      },
      {
        label: 'Vault',
        activeLink: this.activeTab === 'Vault',
        iconAdornmentConfig: {
          enabled: true,
          type: 'icon',
          size: 'large',
          iconName: 'vault'
        },
      }
    ];
  }

  updateBreadcrumbItems = () => {
    if (this.pickerView.parentList && this.pickerView.parentList?.length > 1) {
      Promise.all(
        this.pickerView.parentList.map(async (parent) => {
          try {
            let label = ''; 

            if (parent?.metaname) {
              if (parent.metaname.toLowerCase() === 'web') {
                label = 'Vault'; 
              } else {
                label = await this.crypt.filenameDecrypt(parent.metaname); 
              }
            }

            return {
              label: parent?.metaname === 'web' ? 'Vault' : label === 'Sync' ? 'Files' : label,
              url: parent?.loc_id,
            };
          } catch (error) {
            console.error('Error decrypting filename:', error);
            return {
              label: '', 
              url: parent?.loc_id,
            };
          }
        })
      ).then((breadcrumbItems) => {
        const labelMapping: { [key: string]: { label: string; leadIcon: string } } = {
          files: { label: 'Files', leadIcon: 'folder' },
          vault: { label: 'Vault', leadIcon: 'vault' },
        };

        // Dynamically update labels and icons
        breadcrumbItems.forEach((item) => {
          const key = item.label.toLowerCase();
          if (labelMapping[key]) {
            item.label = labelMapping[key].label;
            item.leadIcon = labelMapping[key].leadIcon;
          }
        });

        // Ensure "Vault" is inserted at index 1 if it doesn't exist
        if (breadcrumbItems.length > 2) {
          const hasVault = breadcrumbItems.some((item) => item.label === labelMapping.vault.label);
          if (!hasVault) {
            breadcrumbItems.splice(1, 0, {
              label: labelMapping.vault.label,
              url: this.dirPickerService.rootVaultId,
              leadIcon: labelMapping.vault.leadIcon,
            });
          }else {
            // If "Vault" is found, add "Files" at the start (index 0)
            breadcrumbItems.splice(0, 0, {
              label: labelMapping.files.label,
              url: this.dirPickerService.rootSyncId, 
              leadIcon: labelMapping.files.leadIcon,
            });
          }
          this.loadTabs();
        }

        this.breadCrumbItems = {
          items: breadcrumbItems,
          maxItem: 2
        };

      });
    } else {
      this.breadCrumbItems = {
        items: [],
        maxItem: 2
      };
    }
  };

  areSelectedItemsInCurrentDir() {
    return this.itemList.length > 0 && this.dirPickerService.view.cwd.id === (this.itemList[0].pid || this.itemList[0].sync_pid) && this.actionMoveOrCopy === WebpathActionType.MOVE;
  }

  isSharedItemInSelectedList = async (itemList: FileItem[]) => {
    const dir_sync_ids: string[] = [];
    for (let i = itemList.length - 1; i >= 0; i--) {
      if (itemList[i].type === 'dir') {
        dir_sync_ids.push(`${itemList[i].sync_id}`)
      }
    }
    if (dir_sync_ids.length === 0) {
      return false;
    }
    const res = await this.batchMoveService.getShareCheck(dir_sync_ids) as any;
    return res?.result ?? {};
  }

  getListFromFileList = async (data: FileItem[]) => {
    this.destinationDataChange.emit(data);
    // Check if all items in the data array are of type "dir"

    this.dirList = [];
    this.isLoading = true;
    this.showInfoOfAlreadyInFolder = 0;    
    const selectedRowConf = {
      dir: 0,
      dirShared: 0,
      file: 0,
      fileShared: 0,
      dirSyncIDs: [],
    }
    this.itemList.forEach((fileItem) => {
      if (fileItem.type === 'dir') {
        selectedRowConf.dir++;
        if ((fileItem.is_share_root === 1 || fileItem?.is_share_root == null && fileItem?.is_shared === 1) || !!this.isParentSharedInSelectedList[fileItem.sync_id]) {
          selectedRowConf.dirShared++;
        }
        selectedRowConf.dirSyncIDs.push(fileItem.sync_id);
      }
      if (fileItem.type === 'file') {
        selectedRowConf.file++;
        if (fileItem.is_shared === 1 || !!this.isParentSharedInSelectedList[fileItem.sync_id]) {
          selectedRowConf.fileShared++;
        }
      }
    });
    
    for (let i = data.length - 1; i >= 0; i--) {
      const fileItem = data[i];
      let isDisabled = (fileItem.is_readonly === 1 || fileItem.is_deleted === 1);
      let permissionMsg = '';
    if (isDisabled) {
        permissionMsg = 'You do not have edit permissions';
      } 
      else if (this.selectedRowDirObject[fileItem.sync_id]) {
        permissionMsg = `You cannot ${this.actionMoveOrCopy === WebpathActionType.COPY ? 'copy' : 'move'} folders into itself`;
        isDisabled = true;
      }
      else if 
        ((this.actionMoveOrCopy === WebpathActionType.MOVE
          || this.actionMoveOrCopy === WebpathActionType.JOINSHARE) 
          && selectedRowConf.dirShared 
      && fileItem.is_share_root
        ) {
        isDisabled = true;
        permissionMsg = 
        this.actionMoveOrCopy === WebpathActionType.JOINSHARE ? 
        'You cannot place a shared folder into another shared folders' :
        'You cannot move shared folders inside other shared folders.';
      }

      if(selectedRowConf.dirSyncIDs.includes(fileItem.sync_id)){
        this.showInfoOfAlreadyInFolder++;
      }
      this.dirList.push({
        primaryText: fileItem.name,
        secondaryText: permissionMsg,
        isSelected: false,
        divider: false,
        isInteractive: true,
        isSelectable: true,
        leadAdornmentConfig: {
          enabled: true,
          type: 'list-head',
          size: 'large',
          data: fileItem,
          iconName: this.fileItemService.getFileTypeIcon(fileItem),
        },
        trail2AdornmentConfig: {
          enabled: !(isDisabled),
          type: 'iconButton',
          size: 'large',
          iconButtonConfig: {
            iconName: (fileItem.is_readonly === 1 || fileItem.is_deleted === 1) || (this.actionMoveOrCopy === WebpathActionType.MOVE && selectedRowConf.dirShared && (fileItem.is_shared === 1)) ? '' : 'chevron-right',
            size: 'large',
          },
          onClick: async (event) => {
            event.stopPropagation();
            if (isDisabled) {
              return;
            }  
            await this.cd(fileItem.sync_id)
            this.select(fileItem)
          }
        },
        onClick: () => {
          if (isDisabled) {
            return;
          }
          if (this.dirPickerService.isSelected(fileItem)) {
            this.select(this.dirPickerService.view.cwd as IFile);
          }
          else {
            this.select(fileItem)
          }
        },
        onDoubleClick: () => {
          if (isDisabled) {
            return;
          }
          this.select(fileItem);
          this.cd(fileItem.sync_id)
        },
        isDisabled: (isDisabled),
      });
    };
    this.dirList.sort((a: ListItem, b: ListItem) => a.primaryText.toString().localeCompare(b.primaryText,
      undefined,
      { numeric: true, sensitivity: 'base' }))
    this.lastItemIndex = 0;
    this.loadMore = true;
    this.itemListForLazyLoadData = [];
    this.isLoading = true;
    this.distributedDirectoryList();
    this.isSelectedItemsInCurrentDir = this.areSelectedItemsInCurrentDir();

    // Check for name conflicts in dirList
    const selectedItemName = this.selectedRows[0]?.name;
     if (selectedItemName) {
      const nameConflict = data.some(item => item.name.toLowerCase() === selectedItemName.toLowerCase());

      if (nameConflict) {
        this.alertConfig = {
          type: 'warning',
          description: `Another folder with the same name already exists at this location. Choose a new destination or rename the existing folder.`,
          leadIcon: 'warning',
        };
        this.nameConflictsChange.emit(true);
      } else {
        this.alertConfig = {
          type: 'info',
          description: `Choose where you would like to put the shared folder <span class="folder-name">${selectedItemName}</span> on your Sync account.`,
          leadIcon: 'folder-open',
        };
        this.nameConflictsChange.emit(false);
       }
    }
  }

  public cd = async (sync_id: number) => {
    await this.dirPickerService.cd(sync_id);
    this.getListFromFileList(this.pickerView.dirlist);
    this.updateBreadcrumbItems();
  }
  public select = (item: IFile) => {
    return this.dirPickerService.select(item);
  }
  public selectByName(name: string) {
    return this.dirPickerService.selectByName(name);
  }
  public getDestination() {
    return this.dirPickerService.getDestination();
  }

  public openRoot = async (name: string) => {
    this.isLoading = true;
    await this.dirPickerService.openRoot(name);
    this.dirPickerService.selectByName(name)
    await this.getListFromFileList(this.pickerView.dirlist);
    this.isLoading = false;
  }

  public cdUp() {
    if (this.pickerView.cwd.pid) {
      this.cd(this.pickerView.cwd.pid);
    } else {
      const mode = this.skipShareFolders
        ? this.dirPickerService.INIT_SKIPSHARE
        : this.dirPickerService.INIT_ALL;
      this.dirPickerService.init(mode);
    }
  }

  onListItemClick = (event: MouseEvent, listItem: IFile) => {
    this.select(listItem)
    event.preventDefault();
  }

  public async getParent() {
    this.isLoading = true;
    const item = this.itemList[0];
    if (item) {
      const parentId = item.pid;
      let parentName = '';
      if (this.userService.get('syncus_sync_id') != parentId) {
        if (this.userService.get('web_sync_id') == parentId) {
          parentName = 'Vault';
        } else {
          const parent: any = await this.apiService.execute('pathget', {
            sync_id: parentId,
          });
          parentName = await this.crypt.filenameDecrypt(parent.enc_name);
        }
      }

      if (parentName) {
        await this.dirPickerService.cd(parentId);
        if (!this.dirPickerService.isSelected(item)) {
          this.dirPickerService.select(item);
        }
      } else {
        this.openRoot('sync');
      }
    }

    this.loadTabs();
    this.updateBreadcrumbItems();

    this.isLoading = false;

  }

  getFileConflictCount = async () => {
    if (!this.dirPickerService.view?.selected?.sync_id) {
    }
    const sync_id: number = this.dirPickerService.view?.selected?.sync_id ?? this.dirPickerService.view?.cwd?.sync_id;

    if (sync_id) {
      const { count } = await this.moveActionsService.getDuplicateNameCheck(sync_id, this.itemList)

      this.showInfoOfAlreadyInFolder = count;
    }
  }
}
